var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6279 11.1211V12.0411C22.6267 14.1975 21.9284 16.2958 20.6373 18.0229C19.3461 19.7501 17.5312 21.0136 15.4633 21.625C13.3954 22.2364 11.1852 22.163 9.1624 21.4157C7.13961 20.6684 5.41258 19.2872 4.23889 17.4782C3.0652 15.6692 2.50772 13.5292 2.64961 11.3774C2.79149 9.22569 3.62514 7.17745 5.02621 5.5382C6.42728 3.89894 8.32072 2.75651 10.4241 2.28127C12.5275 1.80603 14.7282 2.02346 16.6979 2.90112",
    stroke: "#6AC155",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6279 4.04102L12.6279 14.051L9.62793 11.051",
    stroke: "#6AC155",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessAlert);
export default __webpack_public_path__ + "static/media/success_alert.89e4faf7c3ec0760168dce5228ea7a3e.svg";
export { ForwardRef as ReactComponent };